/*
  Sets `--screen-height` on <html>: the small viewport height (100svh) in px, held still while
  only the height of the viewport changes.

  Safari keeps svh fixed while its toolbars collapse and expand. In-app browsers (Instagram,
  Facebook, LinkedIn …) instead resize the web view itself whenever their toolbars slide in or
  out, and every viewport unit follows, svh included. A block whose height is a multiple of the
  screen (the full-screen scroll gallery is up to ten screens tall) then grows or shrinks by that
  multiple of the toolbar height, and everything below it jumps by up to a whole screen.

  On touch screens a height-only change is browser chrome or the keyboard, so the value is only
  measured again when the width changes (rotation, split view). With a mouse it is a window being
  resized, and plain 100svh (the CSS fallback) follows it - so the variable is not set at all.
  Before this runs (server render) the fallback is the same value.
*/
export function track_screen_height() {
  if (!matchMedia('(pointer: coarse)').matches) return () => {};

  const root = document.documentElement;
  let width;

  function update() {
    // clientWidth is the layout viewport - pinch zoom does not change it, unlike innerWidth on iOS
    if (root.clientWidth === width) return;
    width = root.clientWidth;
    const probe = document.createElement('div');
    probe.style.cssText = 'position: fixed; top: 0; width: 0; height: 100svh; visibility: hidden; pointer-events: none;';
    document.body.append(probe);
    root.style.setProperty('--screen-height', `${probe.offsetHeight}px`);
    probe.remove();
  }

  update();
  window.addEventListener('resize', update);
  return () => {
    window.removeEventListener('resize', update);
    root.style.removeProperty('--screen-height');
  };
}
